<template>
  <div>
    <b-modal
      size="lg"
      centered
      hide-footer
      hide-header
      id="reassignmodal"
      :visible="showModal"
      no-close-on-backdrop
      @hidden="handleModalHidden"
    >
      <b-overlay :show="showSpinner">
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="teams-modal-head">
            {{ type ? "Assign Panelist" : "Reassign" }}
          </div>
          <div @click="$emit('close-modal')">
            <img
              :style="showButtonLoader ? 'opacity:50%' : ''"
              src="../../../assets/New-imgs/teams-icons/teams-close-icon.svg"
              alt=""
              :class="!showButtonLoader ? 'pointer rotate-on-hover' : ''"
            />
          </div>
        </div>
        <hr class="m-0" />
        <div class="">
          <div class="px-3 pt-3">
            <div class="relativeclass w-100 teams-innerInputField">
              <img
                class="teams-setImage"
                src="../../../assets/img/search-bar-icon.svg"
                alt=""
              />

              <b-form-input
                :placeholder="type ? 'Search' : 'Search recruiters'"
                type="search"
                v-model="searchRecruiter"
                @input="filterOptions"
                @keyup="filterOptions"
                class="search-input"
              >
              </b-form-input>
            </div>
            <div
              class="reassign-info-txt mt-2 d-flex align-items-center"
              v-if="$route.name == 'Kanban' && !type"
            >
              <img
                src="../../../assets/img/newkanban/info.svg"
                class="mr-2"
                alt=""
              />
              Only recruiters who work on this job can be reassigned.
            </div>
          </div>
          <hr />

          <div class="d-flex align-items-center justify-content-between ml-3">
            <div class="reassign-modal-headtxt">
              {{ type ? "Select Panelist" : "Recruiters" }}
            </div>
            <!-- <div class="reassign-blue-txt">Selected User: 02</div> -->
          </div>

          <div
            class="teams-addUser-container-height pr-0"
            style="height: calc(100vh - 415px)"
          >
            <template v-if="filteredRecruiterList.length == 0 && !showSpinner">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  h-100
                  w-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../../assets/New-imgs/teams-icons/teams-adduser-empty-img.svg"
                    alt=""
                  />
                </div>
                <div
                  v-if="searchRecruiter"
                  class="mt-2 teams-empty-container-font"
                >
                  No matching results for "{{ searchRecruiter }}"
                </div>
                <div v-else class="mt-2 teams-empty-container-font">
                  No {{ type ? "panelists" : "recruiters" }} found.
                </div>
              </div>
            </template>
            <div v-else class="px-3 pt-2">
              <div
                class="
                  p-510px
                  d-flex
                  align-items-center
                  justify-content-between
                  teams-addUser-container
                  pointer
                  mb-3
                  w-100
                "
                v-for="(recruiter, index) in filteredRecruiterList"
                :key="index"
                @click="
                  !checkAssignedRecruiter(recruiter.userID)
                    ? (selectedRecruiter = recruiter)
                    : ''
                "
                :style="
                  !type &&
                  checkAssignedRecruiter(recruiter.userID) &&
                  'opacity: 0.5;'
                "
                :class="
                  !type && checkAssignedRecruiter(recruiter.userID)
                    ? 'disable-inputField'
                    : recruiter.userID == selectedRecruiter.userID
                    ? 'kanban-rec-sel'
                    : ''
                "
              >
                <div class="d-flex align-items-center w-50">
                  <div class="w-100">
                    <div
                      class="teams-addUser-container-head text-truncate w-100"
                    >
                      {{ recruiter.username }}
                      <span
                        class="metxt"
                        v-if="recruiter.userID == roleValues.userID"
                        >(Me)</span
                      >
                    </div>
                    <div class="teams-addUser-container-subhead text-truncate">
                      {{ recruiter.email }}
                    </div>
                  </div>
                </div>
                <div class="w-50 d-flex align-items-center justify-content-end">
                  <div class="reassign-rpa-boxes">
                    {{ recruiter.roleName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="m-0" />

        <div
          class="
            d-flex
            align-items-center
            justify-content-end
            bluebtn
            my-2
            px-3
            py-2
          "
        >
          <b-button
            class="acs-cancelBtn-modal w-105px mr-3"
            @click="$emit('close-modal')"
            :disabled="showButtonLoader"
            >Cancel</b-button
          >
          <div class="addpanellog position-relative">
            <b-button
              :class="
                showButtonLoader && type
                  ? 'selpan-loader-class'
                  : showButtonLoader
                  ? 'givefeed-loader-class'
                  : 'pointer'
              "
              class="acs-addBtn-modal w-105px"
              :disabled="
                Object.keys(selectedRecruiter).length == 0 &&
                assignedRecruiters.length == 0
              "
              @click="
                type
                  ? sendScreening()
                  : $route.name == 'Kanban'
                  ? assignRec()
                  : reassignRec()
              "
            >
              <span v-if="!showButtonLoader">
                {{ type ? "Send for Screening" : "Re-Assign" }}
              </span>
            </b-button>
            <div
              v-if="showButtonLoader"
              :class="type ? 'selpan-loader-pos' : 'loader-pos'"
            >
              <Loader />
            </div>
          </div>
        </div>
      </b-overlay>
    </b-modal>
    <ReassignModal
      v-if="showReassignModal"
      :reassignedDetails="reassignedDetails"
      :showReassignModal="showReassignModal"
      @handle-close="closeModal"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  getJdRecruiters,
  getRecruiters,
  changePositionID,
  getReassignData,
  getReassignRec,
  sendForScreening,
} from "../../../utils/apiFunctions";
import ReassignModal from "../../../controllers/JD/modals/ReassignModal.vue";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import toast from "../../mixin/toast.js";

export default {
  name: "Reassign",
  components: {
    ReassignModal,
    Loader,
  },
  mixins: [toast],
  props: {
    type: Boolean,
    showModal: Boolean,
    particularJob: Object,
    selectedCandidate: Object,
    candidateSelected: Array,
    screeningCands: Array,
  },
  data() {
    return {
      showButtonLoader: false,
      showSpinner: false,
      showReassignModal: false,
      recruiterList: [],
      filteredRecruiterList: [],
      selectedRecruiter: {},
      searchRecruiter: "",
      assignedRecruiters: [],
      reassignedDetails: {},
      isSwitchingModal: false,
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
      roleValues: "getRoleValues",
    }),
  },
  created() {
    this.getRecruiters();
  },
  methods: {
    async sendScreening() {
      try {
        this.showButtonLoader = true;
        let payload = {
          candidateIDs: this.screeningCands,
          assignedTo: this.selectedRecruiter.userID,
          jobID: this.particularJob.jobID,
        };
        const res = await sendForScreening(payload);
        if (res.status == 200) {
          this.$emit("close-modal");
          this.$emit("hide-screening");
          this.$emit("update-details");
          this.dynamicToast(
            "success",
            `Success`,
            "Successfully sent for screening."
          );
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.errorModal("Something went wrong!");
      } finally {
        this.showButtonLoader = false;
      }
    },
    checkAssignedRecruiter(userID) {
      if (this.$route.name == "Kanban" && !this.type) {
        return this.selectedCandidate.customerID[this.$route.query.customerID][
          this.$route.query.jobID
        ].addedBy.includes(userID);
      }
      return false;
    },
    closeModal() {
      this.showReassignModal = false;
      this.$emit("handle-reset");
    },
    handleModalHidden() {
      if (this.isSwitchingModal) {
        this.isSwitchingModal = false;
      } else {
        this.$emit("close-modal");
      }
    },
    toggleRecruiterSelection(recruiter) {
      if (this.$route.name == "TalentPool") {
        const index = this.assignedRecruiters.findIndex(
          (r) => r.userID === recruiter.userID
        );
        if (index > -1) {
          this.assignedRecruiters.splice(index, 1);
        } else {
          this.assignedRecruiters.push(recruiter);
        }
      } else {
        this.selectedRecruiter = recruiter;
      }
    },
    isSelected(recruiter) {
      if (this.$route.name == "TalentPool") {
        return this.assignedRecruiters.some(
          (selected) => selected.userID === recruiter.userID
        );
      } else {
        return (
          this.selectedRecruiter &&
          this.selectedRecruiter.userID === recruiter.userID
        );
      }
    },
    async getRecruiters() {
      try {
        this.showSpinner = true;
        var res;
        if (this.$route.name == "Kanban") {
          if (this.particularJob.recruiterConfig.selectAll || this.type) {
            let payload = {
              licenseKey: this.licenseKey,
              searchQuery: "",
              permission: this.type ? "PROFILE_SCREENING" : "GET_JOBDASHBOARD",
            };
            res = await getRecruiters(payload);
          } else {
            let payload = {
              jobID: this.particularJob.jobID,
              customerID: this.particularJob.customerID,
            };
            res = await getJdRecruiters(payload);
          }
        } else if (this.$route.name == "TalentPool") {
          let payload = {
            searchQuery: "",
            licenseKey: this.licenseKey,
          };
          res = await getReassignData(payload);
        }
        if (res.status == 200) {
          this.showSpinner = false;
          this.recruiterList = res.data.data;
          this.filteredRecruiterList = res.data.data;
        }
      } catch (error) {
        console.error("An error occurred while fetching recruiters:", error);
        this.dynamicToast(
          "error",
          "Error fetching recruiters",
          "There was an error while fetching the recruiters. Please try again."
        );
      }
    },

    filterOptions() {
      if (this.searchRecruiter == "" || this.searchRecruiter == null) {
        this.filteredRecruiterList = this.recruiterList;
      } else {
        // Filter options that start with or contain the selected input
        const startsWithSelected = this.recruiterList.filter(
          (option) =>
            option.username
              .toLowerCase()
              .startsWith(this.searchRecruiter.toLowerCase()) ||
            option.email
              .toLowerCase()
              .startsWith(this.searchRecruiter.toLowerCase())
        );

        const containsSelected = this.recruiterList.filter(
          (option) =>
            !option.username
              .toLowerCase()
              .startsWith(this.searchRecruiter.toLowerCase()) &&
            !option.email
              .toLowerCase()
              .startsWith(this.searchRecruiter.toLowerCase()) &&
            (option.username
              .toLowerCase()
              .includes(this.searchRecruiter.toLowerCase()) ||
              option.email
                .toLowerCase()
                .includes(this.searchRecruiter.toLowerCase()))
        );

        // Concatenate startsWithSelected options followed by containsSelected options
        this.filteredRecruiterList = [
          ...startsWithSelected,
          ...containsSelected,
        ];
      }
    },

    async assignRec() {
      this.showButtonLoader = true;
      let payload = {
        candidateID: this.selectedCandidate.candidateID,
        jobID: this.particularJob.jobID,
        to: this.selectedRecruiter.userID,
        from: this.selectedCandidate.customerID[this.$route.query.customerID][
          this.$route.query.jobID
        ].addedBy,
        type: 2,
        oldPositionID: this.selectedCandidate.positionID,
        automatic: true,
      };
      const res = await changePositionID(payload);
      if (res.status == 200) {
        this.$emit("close-modal");
        this.$emit("update-details");
        this.searchRecruiter = "";
        // this.$nextTick(() => {
        var text = `Candidate "${this.selectedCandidate.name}" has been assigned to recruiter "${this.selectedRecruiter.username}"`;
        this.dynamicToast("reassign", `Successfully re-assigned`, text);
        // });
      } else {
        this.showButtonLoader = false;
        this.errorModal("Something went wrong!");
      }
    },

    async reassignRec() {
      try {
        this.showButtonLoader = true;
        let payload = {
          candidateIDs: this.candidateSelected,
          recruiterUserID: this.selectedRecruiter.userID,
        };

        const res = await getReassignRec(payload);

        if (res.status === 200) {
          this.reassignedDetails = res.data.data;
          this.showButtonLoader = false;
          this.searchRecruiter = "";
          this.isSwitchingModal = true;
          this.$bvModal.hide("reassignmodal");

          setTimeout(() => {
            this.showReassignModal = true;
          }, 300);
        }
      } catch (error) {
        this.showButtonLoader = false;
        console.error("An error occurred during reassignment:", error);
        this.dynamicToast(
          "reassign",
          "Error during reassignment",
          "There was an error while reassigning the candidate. Please try again."
        );
      }
    },
  },
};
</script>
<style>
.selpan-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 155px;
}
.selpan-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 32px;
}
.kanban-rec-sel {
  background: #e1eef7;
}
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.givefeed-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 95px;
}
</style>
